// extracted by mini-css-extract-plugin
export default {"mn-marking":"index_mn-marking__2V2IR"};